export const FormCreateDataRenewableEnergy = {
  id: null,
  name: null,
  name_touched: false,
  konversi_pln: null,
  konversi_pln_touched: false,
  active: false,
  deleted: false,
  is_touched: false,
  action: null,
};

export const FormValidasiDataRenewableEnergy = {
  name: [(v) => !!v?.trim() || "Nama harus diisi"],
  konversi_pln: [
    (v) => !!v?.trim() || "Konfersi pln harus diisi",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Konfersi pln tidak boleh berakhir dengan koma.",
  ],
};
